module.exports = __webpack_public_path__ + "static/media/kp.2b85d60f.svg";